"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UIStepperInput = _interopRequireDefault(require("UIComponents/input/UIStepperInput"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _SkeletonLoadWrapper = _interopRequireDefault(require("../loading/SkeletonLoadWrapper"));

var _MerchCardTermSelectorContainer = _interopRequireDefault(require("./MerchCardTermSelectorContainer"));

var _HighlightedMerchPriceDisplay = _interopRequireDefault(require("pricing-pages-unified-ui/components/product-pages/HighlightedMerchPriceDisplay"));

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _PurchaseTypes = require("self-service-api/constants/PurchaseTypes");

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _PricingSelectors = require("../../selectors/PricingSelectors");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

var _ContactsSelectors = require("../../selectors/ContactsSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  min-width: 60px;\n  width: ", ";\n  display: inline-flex !important;\n  margin: 0 2px;\n\n  & input {\n    font-size: 14px;\n    height: 34px;\n    padding: 6px !important;\n  }\n\n  & .UIButtonGroup {\n    width: 24px !important;\n    margin-left: -25px !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SmallStepperInput = (0, _styledComponents.default)(_UIStepperInput.default).withConfig({
  displayName: "Mon279StepperHeader__SmallStepperInput",
  componentId: "sc-1efrno3-0"
})(_templateObject(), function (_ref) {
  var value = _ref.value;
  return "calc(" + value.toString().length + "em + 30px)";
});

var Mon279StepperHeader = function Mon279StepperHeader(_ref2) {
  var hasPricingAndPurchasingSucceeded = _ref2.hasPricingAndPurchasingSucceeded,
      hub = _ref2.hub,
      merchandiseId = _ref2.merchandiseId,
      headerConfig = _ref2.headerConfig,
      activeTerm = _ref2.activeTerm,
      setActiveTerm = _ref2.setActiveTerm,
      currencyCode = _ref2.currencyCode,
      getAdditionalContactsMonthlyCost = _ref2.getAdditionalContactsMonthlyCost,
      merchandiseMap = _ref2.merchandiseMap,
      getQuantityMultiplier = _ref2.getQuantityMultiplier,
      additionalUnitQuantity = _ref2.additionalUnitQuantity,
      setAdditionalUnitQuantity = _ref2.setAdditionalUnitQuantity;
  if (!hasPricingAndPurchasingSucceeded) return null;
  var title = headerConfig.title,
      icon = headerConfig.icon;
  var merchPurchaseType = _HubMap.default[hub].merchPurchaseType;
  var _merchandiseMap$merch = merchandiseMap[merchandiseId],
      min = _merchandiseMap$merch.includedAdditionalUnits,
      max = _merchandiseMap$merch.maxAdditionalUnits;
  var stepSize = getQuantityMultiplier(merchandiseId) || 1;
  var includedUnitsPickerStringKey = null;

  if (merchPurchaseType === _PurchaseTypes.CONTACT_BASED) {
    includedUnitsPickerStringKey = 'mon279.contactsSelection_jsx';
  } else if (merchPurchaseType === _PurchaseTypes.SEAT_BASED) {
    includedUnitsPickerStringKey = 'mon279.usersSelection_jsx';
  }

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_UIFlex.default, {
    justify: "between",
    direction: "row"
  }, _react.default.createElement("div", {
    className: "m-right-1"
  }, _react.default.createElement(_UIImage.default, {
    className: "display-inline",
    src: icon
  }), _react.default.createElement("h2", {
    className: "m-bottom-0"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: title
  }))), _react.default.createElement(_SkeletonLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded,
    heights: ['0.75em', 30, 10],
    widths: [60, 60, 60]
  }, _react.default.createElement(_HighlightedMerchPriceDisplay.default, {
    merchandiseId: merchandiseId,
    activeTerm: activeTerm,
    additionalUnitQuantity: additionalUnitQuantity,
    hub: hub
  }))), _react.default.createElement("div", {
    className: "m-y-4"
  }, includedUnitsPickerStringKey && _react.default.createElement(_Small.default, {
    use: "help",
    style: {
      lineHeight: '30px'
    }
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: includedUnitsPickerStringKey,
    elements: {
      Input: SmallStepperInput
    },
    options: {
      onChange: function onChange(_ref3) {
        var value = _ref3.target.value;
        return setAdditionalUnitQuantity(value - min);
      },
      value: additionalUnitQuantity + min,
      min: min,
      max: max || 999999,
      stepSize: stepSize
    }
  }), _react.default.createElement(_UIHelpIcon.default, {
    style: {
      marginLeft: '2px'
    },
    size: "small",
    title: merchPurchaseType === _PurchaseTypes.CONTACT_BASED ? _react.default.createElement(_FormattedJSXMessage.default, {
      message: "mon279.contactsSubtext.additionalContacts_jsx",
      elements: {
        Price: _PriceDisplay.default
      },
      options: {
        currencyCode: currencyCode,
        price: getAdditionalContactsMonthlyCost(merchandiseId, activeTerm)
      }
    }) : _react.default.createElement(_FormattedMessage.default, {
      message: "mon279.usersSubtext.freeUsers"
    })
  }))), _react.default.createElement("div", {
    style: {
      width: '100%',
      textAlign: 'center'
    }
  }, _react.default.createElement(_MerchCardTermSelectorContainer.default, {
    activeTerm: activeTerm,
    merchandiseId: merchandiseId,
    onChange: function onChange(term) {
      return setActiveTerm(term);
    }
  })));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    getAdditionalContactsMonthlyCost: (0, _PricingSelectors.getAdditionalContactsMonthlyCostSelector)(state),
    merchandiseMap: (0, _MerchandiseSelectors.merchandiseSelector)(state),
    getQuantityMultiplier: function getQuantityMultiplier(merchId) {
      return (0, _ContactsSelectors.contactsQuantityMultiplierSelector)(state, merchId);
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(Mon279StepperHeader);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/product-pages/Mon279StepperHeader.js
// module id = 840
// module chunks = 5 6